import moment from 'moment';
import { ACITONCOPYRIGHT } from '../../../actionTypes';
export function getSearchToutu(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_SEARCH_TOUTUINFO,
		payload,
		callback,
		errorCallback
	};
}
export function setGalleryImgPraise(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.FETCH_GALLERYIMG_PRAISE,
		payload,
		callback,
		errorCallback
	};
}

export function handleImgData(imgList = []) {
	let array = [];
	console.log('imglist', imgList);
	imgList = imgList || [];
	for (let i = 0, j = imgList.length; i < j; i++) {
		let item = imgList[i];
		let mutil = false;
		// if (get(item, 'responseList.length', 0) > 1) {
		// 	mutil = true;
		// }
		// if (!get(item, 'responseList', '')) {
		// 	continue;
		// }
		let {
			id,
			duration,
			sectionId,
			likeStatus,
			key,
			thumbKey,
			thumbVideoUrl,
			width,
			height,
			size,
			description,
			sectionDescription,
			section,
			addTime,
			contentId,
			originalUrl,
			darkOriginalUrl,
			midUrl,
			avatar,
			nickname,
			endorseCount,
			type
		} = item;
		array.push({
			id,
			mutil,
			duration,
			sectionId,
			likeStatus,
			url: key,
			smallUrl: thumbKey,
			thumbVideoUrl,
			width: width,
			height: height,
			size,
			//title: description, //description || '##',
			date: moment(addTime).format('YYYY-MM-DD') || moment(new Date()).format('YYYY-MM-DD'),
			descHeight: (124 * 2) / 75, // 57,
			contentId,
			section,
			description,
			sectionDescription,
			originalUrl,
			darkOriginalUrl,
			midUrl,
			avatar,
			nickname,
			endorseCount,
			type
		});
	}
	return {
		columns: 2,
		columnWidth: 360 / 75, //165,180
		gutter: 10 / 75, //5px
		items: array
	};
}
export function handleIndexData(imgList = [], index) {
	let array = [];
	imgList = imgList || [];
	// let items = imgList[index].responseList || [];
	// let items = imgList[index] || [];
	for (let i = 0, j = imgList.length; i < j; i++) {
		let {
			id,
			topicId,
			duration,
			sectionId,
			likeStatus,
			key,
			thumbKey,
			thumbVideoUrl,
			width,
			height,
			size,
			description,
			section,
			addTime,
			contentId,
			originalUrl,
			darkOriginalUrl,
			midUrl,
			avatar,
			nickname,
			endorseCount,
			type
		} = imgList[i];
		array.push({
			id,
			topicId,
			duration,
			sectionId,
			likeStatus,
			url: key,
			smallUrl: thumbKey,
			thumbVideoUrl,
			width: width,
			height: height,
			size,
			//title: description, //description || '##',
			date: moment(addTime).format('YYYY-MM-DD') || moment(new Date()).format('YYYY-MM-DD'),
			descHeight: (124 * 2) / 75, // 57,
			contentId,
			section,
			description,
			originalUrl,
			darkOriginalUrl,
			midUrl,
			avatar,
			nickname,
			endorseCount,
			type
		});
	}
	return {
		columns: 2,
		columnWidth: 330 / 75, //165,
		gutter: 10 / 75, //5px
		items: array
	};
}
